@if (!loading) {
<div class="product-order-container">
  <div class="-main">
    <div class="-head">
      <h1>All Products Testing Diepak</h1>
      @if (isSearchEnabled) {
      <div class="product-search-input-container">
        <lucide-icon name="search" class="product-search-icon" size="16"></lucide-icon>
        <input
          id="-product-search-input"
          [value]="searchTerm"
          (input)="onSearchChange($event)"
          type="text"
          placeholder="Search by product name & description"
          autocomplete="off" />
      </div>
      }
    </div>
    @if (!isResponsiveApplicable) {
    <section class="-left-content">
      @if (categoryData) {
      <app-category-sidebar [categoryData]="categoryDataWithCounts" (categorySelected)="onCategorySelection($event)">
      </app-category-sidebar>
      }
      <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
    </section>
    }
    <section class="-right-content">
      @if (dataLoaded) {
      <section class="-sort-filter" [class.responsive-screen]="!isResponsiveApplicable">
        <section class="-multi-filter">
          @if (isResponsiveApplicable && categoryDataWithCounts) {
            <multi-select-dropdown
              #hierarchyCategoryDropdown
              id="category-filter"
              [buttonTitle]="categoryPlaceholder"
              [tree]="hierarchicalCategoryTree"
              [isHierarchicalData]="true"
              [showCounts]="false"
              [showClearButton]="true"
              [breakpointActive]="isResponsiveApplicable"
              (selectionChange)="onHierarchicalCategoriesChange($event)"
              (cleared)="onHierarchicalCategoriesCleared()">
            </multi-select-dropdown>
          }
          <multi-select-dropdown
            id="product-filter"
            [buttonTitle]="productTypePlaceholder"
            [showClearButton]="true"
            [dropdownContent]="productTypeDropdown$ | async"
            (optionSelected)="onDropdownSelected('productType', $event)">
          </multi-select-dropdown>
          <multi-select-dropdown
            id="business-filter"
            [buttonTitle]="businessTypePlaceholder"
            [showClearButton]="true"
            [dropdownContent]="businessTypeDropdown$ | async"
            (optionSelected)="onDropdownSelected('businessType', $event)">
          </multi-select-dropdown>
          <multi-select-dropdown
            id="region-filter"
            [buttonTitle]="regionPlaceholder"
            [showClearButton]="true"
            [dropdownContent]="regionDropdown$ | async"
            (optionSelected)="onDropdownSelected('region', $event)">
          </multi-select-dropdown>
        </section>
        <section class="-results-header">
          @if (isAnyFilterApplied) {
          <span class="clear-filter" (click)="onClearFilter()">Clear Filters</span>
          }
          <p>{{ productDetails.length }} results</p>
        </section>
        @if (isResponsiveApplicable) {
        <section class="-solution-finder-responsive">
          <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
        </section>
        }
      </section>
      } @if (productDetails?.length === 0) {
      <div class="no-results-container">
        <div class="no-results-header">No results found</div>
        <div class="no-results-text">Try adjusting your filters or try a different keyword</div>
        <div class="-secondary-paragraph">
          Or try our
          <app-link to="/solution-finder" class="no-results-link">Solution Finder</app-link>
        </div>
      </div>
      }
      <section class="-results-container">
        @for (product of productDetails; track trackByProductIdentity($index, product)) {
        <div class="card-wrapper">
          <card-category-product
            class="card-category"
            totype="title"
            [title]="product.productTitle"
            [to]="product.productTo"
            [indicators]="product.indicators">
            <p>{{ product.productDescription }}</p>
            <span class="-product-pill">
              @if (showRegions) {
                @for (region of splitRegions(product.region); track region) {
                  <pill-country [icon]="countryIconName(region)">
                    {{ region }}
                  </pill-country>
                }
              }
              @if (showTags) {
                @for (tag of product.tags; track tag) {
                  <pill-country>
                    {{ tag }}
                  </pill-country>
                }
              }
            </span>
          </card-category-product>
        </div>
        }
      </section>
    </section>
  </div>
  @if (body) {
    <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"></content-viewer>
  }
</div>
}
